import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '..';

export const selectAllTasks = createSelector(
  (state: AppState) => state.tasks,
  (tasks) => tasks,
);
